import { SEVERITY } from "@/lib/checker-icons";
import { ChevronRight, Info } from "lucide-react";

const CONFIDENCE = {
  hoog: { label: "Hoog vertrouwen", color: "#059669", bg: "#ECFDF5" },
  gemiddeld: { label: "Gemiddeld vertrouwen", color: "#2563EB", bg: "#EFF6FF" },
  laag: { label: "Laag vertrouwen — juridisch nazicht aangewezen", color: "#D97706", bg: "#FFFBEB" },
};

export default function FindingItem({ finding }) {
  const sev = SEVERITY[finding.severity] || SEVERITY.medium;
  const conf = CONFIDENCE[finding.confidence];

  return (
    <article
      className="rounded-2xl border border-border bg-white p-6 hover:shadow-sm transition-shadow"
      data-testid={`finding-${finding.severity}`}
    >
      <div className="flex items-start gap-4">
        <span
          className="severity-dot mt-2"
          style={{ background: sev.color }}
          aria-hidden="true"
        />
        <div className="flex-1 min-w-0">
          <div className="flex flex-wrap items-center gap-2">
            <h4 className="font-display text-base font-semibold text-ink">
              {finding.title}
            </h4>
            <span
              className="text-[11px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded-full"
              style={{ background: sev.bg, color: sev.text }}
            >
              {sev.label}
            </span>
            {conf && (
              <span
                className="text-[10px] uppercase tracking-wider font-semibold px-2 py-0.5 rounded-full"
                style={{ background: conf.bg, color: conf.color }}
                data-testid={`finding-confidence-${finding.confidence}`}
                title={conf.label}
              >
                {conf.label}
              </span>
            )}
            {finding.category && (
              <span className="text-[11px] uppercase tracking-wider text-ink-soft">
                · {finding.category}
              </span>
            )}
          </div>
          <p className="text-sm text-ink-soft mt-2 leading-relaxed">
            {finding.explanation}
          </p>
          {finding.nuance && (
            <div className="mt-3 flex items-start gap-2 text-xs text-ink-soft bg-blue-50/60 border border-blue-100 rounded-xl p-3 italic">
              <Info className="h-3.5 w-3.5 mt-0.5 text-blue-600 flex-shrink-0" />
              <span><b className="not-italic">Nuance: </b>{finding.nuance}</span>
            </div>
          )}
          {finding.action && (
            <div className="mt-3 flex items-start gap-2 text-sm text-ink bg-slate-50 rounded-xl p-4">
              <ChevronRight className="h-4 w-4 mt-0.5 text-[#002FA7] flex-shrink-0" />
              <span><b>Wat te doen: </b>{finding.action}</span>
            </div>
          )}
          {finding.legal_reference && (
            <p className="text-xs text-ink-subtle mt-3 italic">
              {finding.legal_reference.toLowerCase().startsWith("mogelijk")
                ? finding.legal_reference
                : `Wettelijke basis: ${finding.legal_reference}`}
            </p>
          )}
        </div>
      </div>
    </article>
  );
}
